import { useRef } from "react";
import UploadItem from "./Item";
import "./index.less";
import { Plus } from "@react-vant/icons";
import uploadStore from "@/store/upload";
import { useSearchParams } from "react-router-dom";
import { observer } from "mobx-react";
import { Toast } from "react-vant";

export interface Accept {
  accept?: string; // 支持的文件类型，例如 'image/*' 表示所有图片类型
}

export interface UUploadListWrapperProps {
  accept?: string;
  showName?: boolean;
  imgSize?: string;
  style?: React.CSSProperties;
  uploadParams?: Record<string, any>;
  maxSize?: number; // 单个文件最大大小，单位：mb
  triggerElement?: React.ReactNode;
  onChange?: (res: any[]) => void;
  onComplete?: (res: any[]) => void;
  showOnSuccess?: boolean;
  onItemUploadSuccess?: (res: any) => void;
  onItemClick?: (item: any) => void;
}

const UploadListWrapper = (props: UUploadListWrapperProps) => {
  const {
    style = {},
    showName = true,
    imgSize = "70px",
    maxSize = 1024,
    uploadParams = {},
    triggerElement,
    showOnSuccess = true,
    accept = "video/*,image/*",
    onItemUploadSuccess,
  } = props;
  const [searchParams] = useSearchParams();
  const input = useRef<HTMLInputElement>(null);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    console.log("files----------", Array.from(files));

    const filterFiles = Array.from(files).filter((item) => {
      console.log("item.size", item.size);
      return item.size <= maxSize * 1024 * 1024; // 1GB
    });
    if (filterFiles.length < Array.from(files).length) {
      Toast.info({
        message: `文件大小不能超过${maxSize}MB`,
        duration: 2000,
      });
    }

    // alert(searchParams.get("method"));
    uploadStore.addUploadList({
      projectId: +searchParams.get("project_id") || 0,
      folderId: +searchParams.get("folder_id") || 0,
      files: filterFiles,
      method: searchParams.get("method") || "media",
      count: +searchParams.get("count") || 0, // 小程序端已经上传了几个文件，累计不能超过15个
    });
  };

  return (
    <>
      <div className="upload-list">
        {/* {JSON.stringify(uploadStore.uploadList)}========== */}
        {uploadStore.uploadList
          .filter((item: any) => (!showOnSuccess ? !item.done : true))
          .map((item: any, index) => (
            <UploadItem
              key={index}
              item={item}
              index={index}
              showName={showName}
              imgSize={imgSize}
              style={style}
              params={{
                projectId: Number(item.projectId), // 如果是创作空间素材库过来的会传递project_id过来
                // folder_id同上
                folderId: item.pid,
                fileName: item.name,
                ...uploadParams,
              }}
              onItemClick={props.onItemClick}
              onItemSuccess={(res) => {
                onItemUploadSuccess?.(res);
                // console.log("item upload success", res);
                // setNewList((prevList) =>
                //   prevList.map((item) => {
                //     return res.id === item.id
                //       ? { ...item, done: true, url: res.url }
                //       : item;
                //   })
                // );
                // onItemUploadSuccess?.(res);
                // let newList = [...uploadList];
                // newList.forEach((p: any) => {
                //   if (p.tempFilePath === item.tempFilePath) {
                //     p.done = true;
                //   }
                // });
                // console.log("newList", newList);
                // setNewList(newList);
                // onChange?.(newList);
              }}
            />
          ))}

        <div onClick={() => input.current?.click()}>
          {triggerElement ? null : (
            <div className="add" style={{ width: imgSize, height: imgSize }}>
              <Plus fontSize={24} color="#ccc" />
            </div>
          )}
        </div>

        <input
          ref={input}
          type="file"
          onChange={handleChange}
          multiple
          accept={accept}
          style={{ display: "none" }}
        />
      </div>

      {triggerElement && (
        <div onClick={() => input.current?.click()}>{triggerElement}</div>
      )}
    </>
  );
};

export default observer(UploadListWrapper);
